module.exports = __webpack_public_path__ + "static/img/zhuanti1.0115b699.png";